// extracted by mini-css-extract-plugin
export default {"confirmButton":"ConfirmSweetAlert_confirmButton__vIU05","cancelButton":"ConfirmSweetAlert_cancelButton__Yn8Ta"};